(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/route-result/assets/javascripts/personal-results/personal-result-team.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/route-result/assets/javascripts/personal-results/personal-result-team.js');
"use strict";

const {
  ScoreItem
} = svs.components.marketplaceCompetition.routeResult.highscore;
const {
  CompetitionDetails
} = svs.components.marketplaceCompetition.routeResult.details;
const {
  PositionDirection,
  HighscoreListType
} = svs.components.marketplaceCompetition.services.constants.highscoreConstants;
const {
  FetchState
} = svs.components.marketplaceCompetition.constants;
const PersonalResultsTeam = _ref => {
  var _teamData$drawResults;
  let {
    team,
    useScoreItem = true
  } = _ref;
  if (!team || team.status !== FetchState.Fulfilled) {
    return null;
  }
  const teamData = team === null || team === void 0 ? void 0 : team.data;
  const drawCount = (teamData === null || teamData === void 0 || (_teamData$drawResults = teamData.drawResults) === null || _teamData$drawResults === void 0 ? void 0 : _teamData$drawResults.length) || 0;
  const lastDraw = drawCount > 0 ? teamData.drawResults[teamData.drawResults.length - 1] : undefined;
  const totalCorrects = (teamData === null || teamData === void 0 ? void 0 : teamData.correctCount) || 0;
  const positionChangeSinceLast = lastDraw ? lastDraw.positionChangeSinceLast : 0;
  const position = lastDraw ? lastDraw.position : '-';
  const corrects = lastDraw ? lastDraw.correctCount : '-';
  let direction = PositionDirection.Unmoved;
  if (positionChangeSinceLast > 0) {
    direction = PositionDirection.Up;
  } else if (positionChangeSinceLast < 0) {
    direction = PositionDirection.Down;
  }
  if (!useScoreItem) {
    return React.createElement(CompetitionDetails, {
      drawResults: teamData === null || teamData === void 0 ? void 0 : teamData.drawResults,
      type: HighscoreListType.Team
    });
  }
  return React.createElement(ScoreItem, {
    currentScore: corrects,
    Details: () => React.createElement(CompetitionDetails, {
      drawResults: teamData === null || teamData === void 0 ? void 0 : teamData.drawResults,
      type: HighscoreListType.Team
    }),
    direction: direction,
    isPersonal: true,
    name: teamData === null || teamData === void 0 ? void 0 : teamData.teamName,
    position: position,
    totalScore: totalCorrects
  });
};
setGlobal('svs.components.marketplaceCompetition.routeResult.personalResults.PersonalResultsTeam', PersonalResultsTeam);

 })(window);